module.exports = __webpack_public_path__ + "img/01.d043a69c.jpg";